import ChemiNovaEntityType from "./enums/ChemiNovaEntityType";

class PathInfo {
  constructor(
    public id: number,
    public name: string,
    public entity_type: ChemiNovaEntityType,
    public parent?: PathInfo | undefined,
    public notActiveLink?: boolean
  ) {}
}

export default PathInfo;
